import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { getProjects } from '../../api/butterCMS'
import ProjectListNavigation from './ProjectListNavigation'
import ProjectSlideshow from './ProjectSlideshow'

class ProjectList extends Component {

    constructor(props) {
        super(props);
        this.navigateHandler = this.navigateHandler.bind(this);

        this.state = {
            currentTab: window.location.hash ? window.location.hash.replace('#', '') : '',
            projects: []
        };
    }

    componentDidMount() {
        getProjects({page_size: 5}).then(({ data }) => {
            const { projects } = data
            this.setState({
                projects,
                currentTab: this.state.currentTab || projects[0]['slug']
            })
        })
    }

    navigateHandler(obj) {
        const target = obj.replace('#', '');
        this.setState({
            currentTab: target
        });

        return false;
    }

    render() {
        const { projects } = this.state

        return (
            <div className="c-slideshow">
                <nav className="c-slideshow__nav gamma">
                    <Link className="epsilon u-unstyled" to={'/work'}>Work</Link>
                    <ProjectListNavigation projects={projects} currentTab={this.state.currentTab} clickHandler={this.navigateHandler} />                    
                </nav>
                <div className="c-slideshow__slider">
                    <ProjectSlideshow projects={projects} currentTab={this.state.currentTab} />
                </div>
            </div>
        )
    }


}

export default ProjectList;



// WEBPACK FOOTER //
// ./src/components/Project/ProjectList.js